import React from 'react'

//Bibliotecas
import styled from 'styled-components'

//Componentes
import FlexContainer from '../../../components/common/FlexContainer'
import Avatar from '../../../components/common/Avatar'

function Information({ user }) {


  return (
    <FlexContainer margin='0 64px 64px 64px' borderRadius="20px" minHeight="300px" flexDirection='column' justifyContent='top' boxShadow='20px 20px 40px rgba(0, 0, 0, 0.25)'>
      <Header>
        <Avatar src={user.avatar} width='88px'></Avatar>
      </Header>
      <User>
        <h4>{user.nombre}</h4>
        <span> Rol: <span> {user.rol} </span></span>
        {user.rol != 'docente' &&
          <span> Curso: <span> {user.nombreCurso} </span></span>
        }
      </User>
    </FlexContainer>
  )
}

export default Information

const Header = styled.div`
    width:100%;
    align-self: flex-start;
    height:80px;
    background-color:var(--color-azul-claro); 
    border-radius:20px 20px 0 0;
    img{
      position:relative;
      top: 20px;
      border:10px solid var(--color-blanco);
    }
`;

const User = styled.div`
    display:flex;
    flex-direction:column;
    word-break: break-all;
    padding:0 32px;
    h4{
      margin-top:80px;
      margin-bottom:8px;
    }
    span{
      font-weight:700;
      span{
        font-weight:400;
      }
    }
`;